export default __webpack_public_path__ + "static/media/LogoBlueAndWhite.05af86ec.svg";